import { Container } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { AuthenticatedPage } from '../components/AuthenticatedPage';
import { RoadMapDashboard } from '../components/RoadMap/RoadMapDashboard';
import { useAuthContext } from '../hooks/use-user-auth-context.hooks';
import { CustomUser } from '../redux/slice/auth/CustomUser';
import { dispatchGetCareerRoadMapAssessment } from '../redux/slice/career-roadmap/career-roadmap.operations';
import { dispatchGetLatestRoadmapAI } from '../redux/slice/roadmap-ai/roadmap-ai.operations';
import { dispatchGetUserProfileValues } from '../redux/slice/user-profile';
import { RootState, useAppDispatch } from '../redux/store';

export const RoadMapView: React.FC = () => {
  const { componentName } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user: CustomUser | null = useAuthContext();
  const isAuthenticated = user ? true : false;
  const { isRoadmapAiGenerated } = useSelector((state: RootState) => state.careerRoadmap);

  useEffect(() => {
    if (!isRoadmapAiGenerated) {
      navigate('/generate-roadmap');
    }
  }, [isRoadmapAiGenerated, navigate]);

  useEffect(() => {
    if (isAuthenticated) {
      void dispatch(dispatchGetUserProfileValues());
      void dispatch(dispatchGetCareerRoadMapAssessment());
      void dispatch(dispatchGetLatestRoadmapAI());
    }
  }, [isAuthenticated, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [componentName]);

  return (
    <div className="login-signup-bg ">
      <Container>
        <RoadMapDashboard />
      </Container>
    </div>
  );
};

export const RoadMapPage: React.FC = () => {
  return <AuthenticatedPage render={() => <RoadMapView />} />;
};
